var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74817 14.584L14.3107 14.584V16.1407L3.95129 16.1407L3.95129 15.3623C3.95129 14.8953 4.27005 14.584 4.74817 14.584Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.763794 4.46549C0.763794 2.28611 2.51693 0.57373 4.7482 0.57373L19.8092 0.57373L15.267 6.80055L19.8092 13.0274L4.7482 13.0274C3.3935 13.0274 2.35756 14.0392 2.35756 15.3624L2.35756 16.1408H0.763794L0.763794 4.46549ZM4.7482 11.4707L16.7811 11.4707L13.3545 6.80055L16.7811 2.13044L4.7482 2.13044C3.3935 2.13044 2.35756 3.14229 2.35756 4.46549L2.35756 12.249C2.99506 11.782 3.87163 11.4707 4.7482 11.4707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.73f3a640ed66bd2a81fb5527512ece13.svg";
export { ForwardRef as ReactComponent };